import React from "react";
import { Avatar } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { CallIcon } from "@fluentui/react-icons-northstar";

const CallIconAvatar = (props) => {
  const { size } = props;

  return (
    <Avatar
      data-testid="callIconAvatar"
      icon={<CallIcon />}
      size={size}
    />
  );
};

CallIconAvatar.propTypes = {
  size: PropTypes.string,
};

CallIconAvatar.defaultProps = {
  size: "medium",
};

export default CallIconAvatar;
